@use "../../../../../sedestral/sass/mixins/positioning";
@use "../../../../../sedestral/sass/extends/animations";
@use "../../../../../sedestral/sass/mixins/keyframes";

.globalLoaderLight {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;

  @include positioning.flex-globally;

  .lightContainer {
    width: 100%;
    height: 100%;
    position: relative;

    @include positioning.flex-globally;

    circle {
      stroke-width: 4px;
    }

    svg {
      width: 30px;
      height: 30px;
      @include animations.spinner-loader;
    }
  }
}